import GLOBAL_CONSTANTS from "./GlobalConstant";

// const API_BASE_URL = 'https://salmon-alligator-521357.hostingersite.com/';
const CONSTANTS = {
    API_URL: `${GLOBAL_CONSTANTS.API_BASE_URL}api/auth/v1/`,
    STORE: {
        USER_TOKEN: "token",
        USER_ID: "userId"
    },

    EXTENSION_MIME_TYPE: {
        "xlsx": 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        "docx": 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        "doc": 'application/msword',
        "pdf": 'application/pdf',
        "jpeg": 'image/jpeg',
        "png": 'image/png',
        "jpg": 'image/jpg',
    },
    
    // EXTENSION_ICON_NAME: {
    //     "xlsx": 'fa-file-excel-o',
    //     "docx": 'fa-file-word-o',
    //     "doc": 'fa-file-word-o',
    //     "pdf": 'fa-file-pdf-o',
    //     "jpeg": 'fa-file-image-o',
    //     "png": 'fa-file-image-o',
    //     "jpg": 'fa-file-image-o',
    // },

}

export default CONSTANTS;